export default {
  header: 'Informacje o miejscu "{place}"',
  placeStatus: 'Status miejsca',
  reserved: 'Skryty',
  holdingTime: 'Czas utrzymywania [min]',
  loadStatus: 'Status obciążenia',
  cellLoadNo: 'Numer obciążenia ogniwa',
  targetStartTime: 'Czas rozpoczęcia docelowego',
  bookedOnPlace: 'Zarezerwowane na miejscu',
  plcLoadNo: 'Numer obciążenia PLC',
  box: 'Skrzynka',
  prio: 'Prio',
  comment: 'Komentarz',
  noActiveProcessFlow: 'Brak aktywnego przepływu procesu',
  noParts: 'Brak części',
  processFlow: 'Przepływ procesu',
  content: 'Zawartość',
  confirmStartProcessFlowNow: 'Czy na pewno chcesz teraz rozpocząć przepływ procesu?',
  name: 'Nazwa',
  description: 'Opis',
  booked: 'Zarezerwowane',
  modification: 'Modyfikacja',
  unloaded: 'Rozładowany',
  started: 'Rozpoczęto',
  finished: 'Gotowy',
  loadFinalTest: 'Załaduj test końcowy',
  status: 'Status',
  parts: 'Strony',
  loadingPlace: 'Miejsce załadunku',
};
